import React from 'react';
import './App.css';

import {Routes} from './routes';
function getResumePath() {  
  if (['localhost', '127.0.0.1'].indexOf(window.location.hostname) === -1) {
    console.log('prod', window.location.hostname)
    return '/resume.yaml';
  }
  console.log('dev', window.location.hostname)
  return '/public/resume.yaml';
}

function getNavigation() {
  return {
      home: 'Home',
      about: 'About',
      work: 'Work',
      education: 'Education',
      skill: 'Skills',
      portfolio: 'Portfolio',
      testimonials: 'References'
  };
}

let routes = Routes.get({
  resumePath: getResumePath(),
  navigation: getNavigation()
})


function App() {
  return (
    <div className='main-container'>
      {routes}        
    </div>
  );
}

export default App;
